import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { Reveal } from "./Reveal";
import { useSite } from "@/lib/SiteContext";
import { isPlaceholder } from "@/lib/content";

export const CtaSection = ({ heading = "Ready for a Cleaner Space?", text = "Whether you need a one-off clean, regular home cleaning or a reliable commercial cleaning service, RD Cleaning Services is ready to help." }) => {
  const { settings } = useSite();
  const phone = settings.phone;
  return (
    <section className="relative overflow-hidden bg-navy py-20 sm:py-28">
      <div className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full bg-teal-500/15 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-32 -left-24 h-96 w-96 rounded-full bg-teal-400/10 blur-3xl" />
      <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-6">
        <Reveal>
          <h2 className="font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">{heading}</h2>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg">{text}</p>
          <div className="mt-9 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Link to="/quote" className="focus-ring w-full rounded-full bg-teal-500 px-8 py-4 text-base font-bold text-navy-deep shadow-lg shadow-teal-500/25 transition-all hover:-translate-y-0.5 hover:bg-teal-400 sm:w-auto" data-testid="cta-quote-button">
              Get Your Free Quote
            </Link>
            {!isPlaceholder(phone) ? (
              <a href={`tel:${phone.replace(/\s/g, "")}`} className="focus-ring inline-flex w-full items-center justify-center gap-2 rounded-full border border-white/25 px-8 py-4 text-base font-semibold text-white transition-colors hover:border-teal-300 hover:text-teal-300 sm:w-auto" data-testid="cta-call-button">
                <Phone className="h-5 w-5" /> Call RD Cleaning Services
              </a>
            ) : (
              <Link to="/contact" className="focus-ring inline-flex w-full items-center justify-center gap-2 rounded-full border border-white/25 px-8 py-4 text-base font-semibold text-white transition-colors hover:border-teal-300 hover:text-teal-300 sm:w-auto" data-testid="cta-call-button">
                <Phone className="h-5 w-5" /> Call RD Cleaning Services
              </Link>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
